import React from 'react';
import { Button, Dropdown } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

/**
 * 27.10.2026: fatura kalemlerinden sözleşme ve kabin kaydı düzenleme kısayolu (yeni sekmede açılır; liste ve
 * filtreler korunur). ys: YS sözleşme id, ysk: ys_sozlesme_kayit id, bs: banka sözleşme id, bsk: banka_sozlesme_kayit id.
 * Hedefler: /yer_sozlesme_detay/{ys}[?ysk=] (YskDuzenle açılır), /banka_sozlesme_detay/{bs}[?bsk=] (BskSatirlari açılır).
 */
export const kisayolOgeleri = ({ ys, ysk, bs, bsk }) => [
  ys && { key: 'ys', label: 'YS Sözleşmesini Düzenle', yol: `/yer_sozlesme_detay/${ys}` },
  ys && ysk && { key: 'ysk', label: 'YS Kabin Kaydını (YSK) Düzenle', yol: `/yer_sozlesme_detay/${ys}?ysk=${ysk}` },
  bs && { key: 'bs', label: 'Banka Sözleşmesini Düzenle', yol: `/banka_sozlesme_detay/${bs}` },
  bs && bsk && { key: 'bsk', label: 'Banka Kabin Kaydını (BSK) Düzenle', yol: `/banka_sozlesme_detay/${bs}?bsk=${bsk}` },
].filter(Boolean);

export default function DuzenleKisayolu({ ys, ysk, bs, bsk, darkMode }) {
  const ogeler = kisayolOgeleri({ ys, ysk, bs, bsk });
  if (ogeler.length === 0) return null;
  return (
    <Dropdown trigger={['click']} placement="bottomRight"
      menu={{
        items: ogeler.map(({ key, label }) => ({ key, label })),
        onClick: ({ key }) => window.open(ogeler.find((o) => o.key === key).yol, '_blank'),
      }}>
      <Button size="small" icon={<LinkOutlined />} title="Sözleşme / kabin kaydı düzenle (yeni sekme)"
        className={darkMode ? 'dark-button' : ''}>
        Düzenle
      </Button>
    </Dropdown>
  );
}
